import { en } from './en';
import { ka } from './ka';
import { ru } from './ru';

export const translations = {
  en,
  ka,
  ru,
} as const;